<div
  class="lg:grid lg:grid-cols-[280px_minmax(0,_1fr)] 3xl:grid-cols-[344px_minmax(0,_1fr)]"
>
  <!-- Sidebar -->
  <app-sidenav></app-sidenav>

  <!-- Main Content -->
  <div class="max-w-full max-h-full overflow-y-hidden overflow-x-hidden">
    <!-- Header -->
    <app-header></app-header>
    <!-- Content Wrapper -->
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
